import React from "react";
import { formatCurrency, pluralizeText } from "../../../lib/utils";
import Big from "big.js";

export default class PurchaseInfo extends React.PureComponent {
  state = {
    customQuantity: "",
  };

  onChangeQuantity = (qty) => {
    if (this.state.customQuantity) {
      this.setState({
        customQuantity: "",
      });
    }

    this.props.onChangeQuantity(qty);
  };

  onChangeCustomQuantity = (event) => {
    let customQuantity;

    if (event.target) {
      const {
        target: { value },
      } = event;

      // validate manual entry:
      if (
        (value && !/^\d+$/.test(value)) || // only whole positive numbers allowed
        value === "0" || // leading zeros not allowed
        value > 1000000000 // max 1 billion
      ) {
        event.preventDefault();
        return;
      }

      customQuantity = value ? parseInt(value, 10) : "";
    } else {
      const currentQuantity = this.state.customQuantity
        ? parseInt(this.state.customQuantity, 10)
        : 0;
      customQuantity =
        event === "minus"
          ? currentQuantity > 2
            ? currentQuantity - 1
            : 1
          : event === "add"
          ? currentQuantity + 1
          : currentQuantity;
    }

    this.setState(
      {
        customQuantity,
      },
      () => this.props.onChangeQuantity(customQuantity)
    );
  };

  render() {
    const {
      chabadHouseName,
      currencyCode,
      submitAttempted,
      ticketQuantity,
      ticketPrice,
      ticketOptions,
      termsAndConditions,
      toggleShowTermsAndConditions,
    } = this.props;
    const { customQuantity } = this.state;

    const ticketPriceVal = Big(ticketPrice || 0);

    return (
      <div className="purchase-tickets">
        <p className="background-text mobile-hidden">Tickets</p>
        <div className="light-text text-center">
          <p className="fs-50 fw-700 mb-32">Buy Tickets</p>
          <p className="fs-18 fw-700 mb-16">
            Enter the Grand Draw to support Jewish Students on Campus
          </p>
          <p className="italic-text mb-40">
            All proceeds benefit {chabadHouseName}
          </p>
          <p className="fs-16">
            Select how many tickets you'd like to purchase from these popular
            selections
          </p>
        </div>
        <div className="ticket-qty-grid">
          {ticketOptions.map((qty) => (
            <div
              className={
                !customQuantity && ticketQuantity === qty
                  ? "active ticket-qty-option"
                  : "ticket-qty-option"
              }
              key={qty}
              onClick={() => this.onChangeQuantity(qty)}
            >
              <p className="ticket-qty">
                {qty} {pluralizeText("Ticket", qty)}
              </p>
              <p className="ticket-cost">
                {formatCurrency(ticketPriceVal.times(qty), currencyCode, 0)}
              </p>
            </div>
          ))}
        </div>
        <p className="fs-16 mb-24 light-text text-center">
          Or enter a custom amount of tickets
        </p>
        <div className="flex flex-column flex-align-center">
          <div className="custom-ticket-qty-input">
            <button
              onClick={(e) => {
                e.preventDefault();
                this.onChangeCustomQuantity("minus");
              }}
            >
              -
            </button>
            <input
              autoComplete="custom-qty"
              className={`custom-input text-center ${
                submitAttempted && !ticketQuantity ? "error" : ""
              }`}
              min="1"
              max="1000000000"
              step="1"
              onChange={this.onChangeCustomQuantity}
              type="text"
              value={customQuantity}
            />
            <button
              onClick={(e) => {
                e.preventDefault();
                this.onChangeCustomQuantity("add");
              }}
            >
              +
            </button>
          </div>
          {customQuantity ? (
            <span className="italic-text light-text mt-16">
              {customQuantity} {pluralizeText("Ticket", customQuantity)} ={" "}
              {formatCurrency(
                ticketPriceVal.times(customQuantity),
                currencyCode
              )}
            </span>
          ) : (
            <span className="italic-text light-text mt-16">
              1 Ticket = {formatCurrency(ticketPriceVal, currencyCode)}
            </span>
          )}
        </div>
        <div style={{ width: 1104, maxWidth: "100%", margin: "16px auto 0" }}>
          <p className="italic-text fs-10 light-text">
            * Suggested donation. Each ticket is one entry to the draw.{" "}
            <span
              className="pointer underline-text"
              onClick={(evt) =>
                toggleShowTermsAndConditions(evt, termsAndConditions.legalText)
              }
            >
              Rules and regulations
            </span>
          </p>
        </div>
      </div>
    );
  }
}
